// Generated by genversion.
export const version = '7.0.3';
//# sourceMappingURL=version.js.map